import React, { useState, useReducer, useEffect, useContext } from 'react'
import classes from './PPT.module.css'
import FileCard from '../../../Shared/FileUploaderCard'
import axios2 from 'axios'
import Loader from '../../../Loader'
import Unauthorized from '../../../Unauthorized'
import FileUploader from '../../../Shared/FileUploader'
import axios from '../../../../Axios'
import { Activity, currentRequestTimeStamp, PPT_URL } from '../../../../Constants'
import { Urls } from '../../../../Urls'
import DownloadFile from './pptformat.xlsx'
import { toast } from 'react-toastify'
import { getCompanyFolderName, getUserFolderName } from '../../../../Utility' //getTimeStamp
import mixpanel from 'mixpanel-browser'
import { UserApiContext } from '../../../UserDetailsContext/UserDetailsContext';

const UploadFileAndInputMetrics = ({ userInput, handleChange, volume_options, spend_options, spend_currency_options }) => {
    const onChange = (fileidkey, filenamekey, fileid, filename) => {
        Activity([{ "screen": "Generate PPT", "module": "Generate PPT", "user_activity": `file uploaded`, "timestamp": currentRequestTimeStamp() }])
        getFileDownloadLink(filename)
            .then(res => {
                fileid = res.data.url
                handleChange(fileidkey, fileid)
                handleChange(filenamekey, filename)
            })
            .catch(err => {
                console.log(err)
                toast.error('Somwthing went wrong!')
            })

        handleChange('show', false)
        mixpanel.track(`User has clicked on add excel button`, {
            ApplicationName: `${Urls.mixpanelappname}`,
            ScreenName: 'LoRRI-Analyticsppt',   
            ModuleName: 'analytics_ppt',     
            ActivityLog: 'userClickedAddExcelButton',     
            Data: `${filename}`,     
            Definition: `User has clicked on add excel button`,     
            ActivityType: 'event_view',
            UserName: `${localStorage.getItem("userdetails")}`,
            UserEmail: `${localStorage.getItem("useremail")}`,
            CompanyName: `${localStorage.getItem("companyname")}`
        });
    }

    const getFileDownloadLink = (fileName) => {
        let updatedFileName = `PPTGENERATION_${fileName}`
        updatedFileName = updatedFileName.replace(' ', '_')
        let body = {
            'action': 'download',
            'accountName': 'lnclientdata',
            'containerName': 'ppt-collections',
            'fileName': `${getCompanyFolderName()}/${getUserFolderName()}/raw/${updatedFileName}`
        }
        return axios.post(Urls.fileService, body)
    }

    const Select = ({ label, value, onChange, options = [] }) => {
        return <div className={`${classes['display-flex']} ${classes['flex-direction-row']} `}>
            <div className={`${classes['display-flex']} ${classes['flex-direction-column']} ${classes['metrics-left-col']}`}>
                <label className={`col-form-label`}>
                    {label}
                </label>
            </div>
            <div className={`${classes['display-flex']} ${classes['flex-direction-column']} ${classes['metrics-right-col']}`}>
                <select className={`form-control`} value={value} onChange={e => onChange(e.target.value)}>
                    {options}
                </select>
            </div>
        </div>
    }
    const toggleLoader = () => {
        handleChange('message', 'uploading')
        handleChange('show', true)
    }

    const downloadSamplePPT = () => {
        Activity([{ "screen": "Generate PPT", "module": "Generate PPT", "user_activity": "Sample File Downloaded", "timestamp": currentRequestTimeStamp() }])
        mixpanel.track(`User has clicked on download format button`, {
            ApplicationName: `${Urls.mixpanelappname}`,
            ScreenName: 'LoRRI-Analyticsppt',   
            ModuleName: 'analytics_ppt',     
            ActivityLog: 'userClickedDownloadFormatButton',     
            Data: `None`,     
            Definition: `User has clicked on download format button`,     
            ActivityType: 'event_view',
            UserName: `${localStorage.getItem("userdetails")}`,
            UserEmail: `${localStorage.getItem("useremail")}`,
            CompanyName: `${localStorage.getItem("companyname")}`
        });
    }
    return <>
        <h5 style={{ color: '#393185' }}>Uploads Section</h5>
        {
            // console.log(userInput)
        }
        <span>Please enter data in this format : 
            <a download 
                onClick={() => downloadSamplePPT()}
                href={DownloadFile}>Download
            </a>
        </span>

        <div className={`${classes['display-flex']} ${classes['flex-direction-row']} ${classes['file-uploader-row']}`}>
            <FileCard
                fileInputDivClassName={`${classes['display-flex']} ${classes['flex-direction-row']} ${classes['file-input-div']} `}
                containerclassName={`${classes['display-flex']} ${classes['flex-direction-column']} ${classes['file-upload-row']}`}
                fileid={'ExcelFileId'}
                title='Excel'
                filename={userInput.excel_file_name}
                tootltipInfo="This file to be used for Generating PPT"

            />
            <FileUploader
                fileid='ExcelFileId'
                onChange={(fileid, filename, fileurl) => onChange('file_url', 'excel_file_name', fileurl, filename)}
                supportedFiles={['xlsx']}
                UnsupportedError={"Upload Excel File Only"}
                toggleLoader={toggleLoader}
                uploadedfor="PPTGENERATION"
            />
            <FileCard
                fileInputDivClassName={`${classes['display-flex']} ${classes['flex-direction-row']} ${classes['file-input-div']}`}
                containerclassName={`${classes['display-flex']} ${classes['flex-direction-column']} ${classes['logo-upload-row']}`}
                fileid={'LogoFileId'}
                title='Company Logo(Optional)'
                filename={userInput.logo_file_name}
                tootltipInfo="Logo Uploaded here will be displayed in PPT"
            />
            <FileUploader
                fileid='LogoFileId'
                onChange={(fileid, filename, fileurl) => onChange('logo_url', 'logo_file_name', fileurl, filename)}
                supportedFiles={['png', 'jpg']}
                UnsupportedError={"Upload Png or jpg File Only"}
                toggleLoader={toggleLoader}
                uploadedfor="PPTGENERATION"


            />
        </div>
        {
            userInput.file_url ?
                <>
                    <div className={`${classes['display-flex']} ${classes['flex-direction-column']} `}>
                        <h5 style={{ color: '#393185' }}>Select Metrics</h5>
                        <Select
                            label={'Select Volume Unit :'}
                            value={userInput.volume_unit}
                            onChange={value => handleChange('volume_unit', value)}
                            options={volume_options} />
                        <Select
                            label={'Select Spend Unit :'}
                            value={userInput.spend_unit}
                            onChange={value => handleChange('spend_unit', value)}
                            options={spend_options} />
                        <Select
                            label={'Select Spend Currency :'}
                            value={userInput.spend_currency}
                            onChange={value => handleChange('spend_currency', value)}
                            options={spend_currency_options} />
                        <div className={`${classes['display-flex']} ${classes['flex-direction-row']}`}>
                            <div className={`${classes['display-flex']} ${classes['flex-direction-column']} ${classes['metrics-left-col']}`}>
                                <label className={`col-form-label`}>
                                    Enter Company Name :
                                </label>
                            </div>
                            <div className={`${classes['display-flex']} ${classes['flex-direction-column']} ${classes['metrics-right-col']}`}>
                                <input type="text" className={`form-control`} value={userInput.company_name} onChange={e => handleChange('company_name', e.target.value)} />
                            </div>
                        </div>
                    </div>
                    <div className={`${classes['display-flex']} ${classes['flex-direction-row']} ${classes['justify-content-center']}`}>
                        <button className="btn btn-primary" disabled={!userInput.file_url} onClick={e => handleChange('activeStep', 1)}>Review and Generate PPT</button>
                    </div>
                </>
                : null
        }
    </>
}
const PPTGenerate = props => {
    const [allowed, setAllowed] = useState(false)
    const [unauthorizedContent, setUnauthorizedContent] = useState(<h1>Loading</h1>)
    const [userInput, setUserInput] = useReducer(
        (state, newState) => ({ ...state, ...newState }),
        {

            currentStep: 1,
            volume_unit: 'TruckLoads',
            spend_unit: 'Same',
            spend_currency: 'INR',
            file_url: '',
            logo_url: '',
            company_name: '',
            excel_file_name: "",
            logo_file_name: "",
            // company_name: "",
            logorequired: false,
            activeStep: 0,
            show: false,
            PPTResult: '',
            PPTUrl: '',
            message: 'Generating PPT Please Wait'
        }
    )
    const volume_options = [<option key="TruckLoads" value="TruckLoads">TruckLoads</option>, <option key="MT" value="MT">MT</option>]
    const spend_currency_options = [<option key="INR" value="INR">INR</option>, <option key="USD" value="USD">USD</option>, <option key="EUR" value="EUR">EUR</option>, <option key="AUD" value="AUD">AUD</option>, <option key="AED" value="AED">AED</option>]
    const spend_options = [<option key="Same" value="Same">Same</option>, <option key="Lakhs" value="Lakhs">Lakhs</option>, <option key="Millions" value="Millions">Millions</option>]
    const {userDetails} = useContext(UserApiContext)
    
    const handleChange = (key, value) => {
        if(key === 'activeStep' && value === 1){
            Activity([{ "screen": "Generate PPT", "module": "Generate PPT", "user_activity": `Review and Generate PPT button clicked`, "timestamp": currentRequestTimeStamp() }])
            mixpanel.track(`User has clicked on review and generate ppt button`, {
                ApplicationName: `${Urls.mixpanelappname}`,
                ScreenName: 'LoRRI-Analyticsppt',   
                ModuleName: 'landing_page',     
                ActivityLog: 'userClickedReviewAndGeneratePpt',     
                Data: `None`,     
                Definition: `User has clicked on review and generate ppt button`,     
                ActivityType: 'event_view',
                UserName: `${localStorage.getItem("userdetails")}`,
                UserEmail: `${localStorage.getItem("useremail")}`,
                CompanyName: `${localStorage.getItem("companyname")}`
            });
        }
        else if(key === 'activeStep' && value === 0){
            Activity([{ "screen": "Generate PPT", "module": "Generate PPT", "user_activity": `Previous button clicked`, "timestamp": currentRequestTimeStamp() }])
        }
        else{}
        setUserInput({
            [key]: value
        })
    }
    useEffect(() => {
        mixpanel.track(`User has viewed analytics ppt page`, {
            ApplicationName: `${Urls.mixpanelappname}`,
            ScreenName: 'LoRRI-Analyticsppt',   
            ModuleName: 'landing_page',     
            ActivityLog: 'userViewedAnalyticsPpt',     
            Data: `None`,     
            Definition: `User has viewed analytics ppt page`,     
            ActivityType: 'page_view',
            UserName: `${localStorage.getItem("userdetails")}`,
            UserEmail: `${localStorage.getItem("useremail")}`,
            CompanyName: `${localStorage.getItem("companyname")}`
        });
        setAllowed(userDetails?.policy?.ppt?.allowed === 'yes' ? true : false)
        setUnauthorizedContent(userDetails?.policy?.ppt?.allowed === 'yes' ? <h1>Success</h1> :
            <div className="unauthorized_message" style={{ marginLeft: "-25%" }}>
                <Unauthorized modalID={"PPT_Generation_Wizard"} closemodal={true} message='Your subscription does not include this service!' />
            </div>
        )
        // getUserDetails()
        //     .then(res => {
        //         setAllowed(res.data.policy.ppt.allowed === 'yes' ? true : false)
        //         setUnauthorizedContent(res.data.policy.ppt.allowed === 'yes' ? <h1>Success</h1> :
        //             <div className="unauthorized_message" style={{ marginLeft: "-25%" }}>

        //                 <Unauthorized modalID={"PPT_Generation_Wizard"} closemodal={true} message='Your subscription does not include this service!' />
        //             </div>
        //         )
        //     })
    }, [userDetails])
    const Review = () => {
        const Data = [
            { label: "Excel File Upload Status", value: userInput.file_url ? 'Yes' : 'No' },
            { label: "Volume Unit", value: userInput.volume_unit },
            { label: "Spend Unit", value: userInput.spend_unit },
            { label: "Spend Currency Unit", value: userInput.spend_currency },
            { label: "Company Name", value: userInput.company_name ? userInput.company_name : 'Not Mentioned' },
            { label: "Logo Upload Status", value: userInput.logo_url ? 'Yes' : `No (Note: Since you haven't uploaded your Company Logo Our Company Logo will be attached by default on Generated PPT)` }
        ]

        const requestPPT = async () => {
            Activity([{ "screen": "Generate PPT", "module": "Generate PPT", "user_activity": "Generate PPT button clicked", "timestamp": currentRequestTimeStamp() }])
            mixpanel.track(`User has clicked Generate PPT button`, {
                ApplicationName: `${Urls.mixpanelappname}`,
                ScreenName: 'LoRRI-Analyticsppt',   
                ModuleName: 'landing_page',     
                ActivityLog: 'userClickedGeneratePpt',     
                Data: `None`,     
                Definition: `User has clicked Generate PPT button`,     
                ActivityType: 'page_view',
                UserName: `${localStorage.getItem("userdetails")}`,
                UserEmail: `${localStorage.getItem("useremail")}`,
                CompanyName: `${localStorage.getItem("companyname")}`
            });
            handleChange('show', true)
            handleChange('message', 'Generating PPT Please Wait')
            axios2.post(PPT_URL,
                {
                    "file_url": userInput.file_url,

                    "container_name": "ppt-collections",

                    "spend_currency": userInput.spend_currency,

                    "spend_unit": userInput.spend_unit,

                    "volume_unit": userInput.volume_unit,

                    "company_logo": userInput.logo_url,

                    "company_name": userInput.company_name,

                    'userFileName': sessionStorage.getItem('pptFileName')
                })
                .then(res => {
                    handleChange('PPTResult', true)
                    axios.post(Urls.fileService, {
                        'action': 'download',
                        'accountName': 'lnclientdata',
                        'containerName': 'ppt-collections',
                        'fileName': sessionStorage.getItem('pptFileName')
                    }).then(res => {
                        handleChange('PPTUrl', res.data.url)
                    }).catch(error => {
                        console.log(error)
                        toast.error('Error while parsing download url!')
                    })
                    handleChange('show', false)
                    handleChange('activeStep', 2)

                })
                .catch(err => {
                    handleChange('show', false)
                    handleChange('PPTResult', false)
                    handleChange('activeStep', 2)

                })
        }

        const ReviewRow = ({ item }) => {
            return <div className={`${classes['display-flex']} ${classes['flex-direction-row']} ${classes['Review-Row']}`}>
                <div className={`${classes['display-flex']} ${classes['flex-direction-column']} ${classes['flex-direction-left-column']}`}>
                    {item.label}
                </div>
                <div className={`${classes['display-flex']} ${classes['flex-direction-column']} ${classes['flex-direction-right-column']}`}>
                    {item.value}
                </div>
            </div>
        }
        return <div className={`${classes['display-flex']} ${classes['flex-direction-column']} ${classes['Review-Container']} `}>
            <h5 style={{ color: "#393185" }}>Review Your Inputs</h5>
            {
                Data.map((item, index) => <ReviewRow key={index} item={item} />)
            }
            <div className={`${classes['display-flex']} ${classes['flex-direction-row']} ${classes['justify-content-space']}`}>
                <button className="btn btn-danger" disabled={!userInput.file_url} onClick={e => handleChange('activeStep', 0)}>Previous</button>
                <button className="btn btn-success" disabled={!userInput.file_url} onClick={e => requestPPT()}>Generate PPT</button></div>
        </div>
    }
    const FinalResult = () => {
        useEffect(() => {
            if (userInput.PPTResult) {
                window.open(userInput.PPTUrl, "_blank")
            }
        }, [])
        return <div className={`${classes['display-flex']} ${classes['flex-direction-column']} ${classes['justify-content-space']}`}>
            {
                !userInput.PPTResult ? 'There Was an Error in Generating PPT'
                    : <>
                        PPT has been Generated Successfully If the PPT hasn't Download you can Download Manually by clicking this link
            <a href={userInput.PPTUrl} rel="noopener noreferrer" target="_blank">Click Here</a>
                    </>
            }
            <div className={`${classes['display-flex']} ${classes['flex-direction-row']} ${classes['justify-content-space']}`}>
                <button onClick={e => handleChange('activeStep', 1)} className="btn btn-danger">Back to Review</button>
            </div>
        </div>
    }
    const renderActiveComponent = (currentStep) => {
        switch (currentStep) {
            case 0: return <UploadFileAndInputMetrics
                userInput={userInput}
                handleChange={(key, value) => handleChange(key, value)}
                volume_options={volume_options}
                spend_options={spend_options}
                spend_currency_options={spend_currency_options}
            />
            case 1: return <Review />
            case 2: return <FinalResult />
            default: return
        }
    }
    return (
        <div className={`${classes['display-flex']} ${classes['flex-direction-column']} ${classes['Container']}`}>
            {
                allowed ? <><Loader show={userInput.show} message={userInput.message} />

                    {renderActiveComponent(userInput.activeStep)}
                </> :

                    unauthorizedContent



            }

        </div>
    )
}
export default PPTGenerate
